
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { initializeAtlasDebugFromWindow } from '../../shared/visual-atlas/debug-runtime';
import { aboutWebAtlasDebugAdapter } from '../visual-atlas/debug-adapter';


if (environment.production !== true) {
  initializeAtlasDebugFromWindow(aboutWebAtlasDebugAdapter, window);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
